module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dwU7H"))).then(() => parcelRequire('hEqeo'));